import './frontend.scss';

import {Application} from '@hotwired/stimulus';
import MainController from './frontend/main-controller';
import DateFacetController from './frontend/date-facet-controller';

const application = Application.start();
application.debug = process.env.NODE_ENV === 'development';
application.register('t42fes', MainController);
application.register('t42fes-date', DateFacetController);
